import React from 'react'
import { Button, Row, Col, Card, Icon, Input } from 'antd';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  StripeProvider,
  Elements,
  injectStripe,
} from 'react-stripe-elements';

import {StyledMember, StyledStripeForm} from './style'
import global_config from '../../utils/constants'

class _SplitForm extends React.Component {

  state = {
    error: '',
    success: '',
    ActiveTab: "creditCard",
    name: '',
    address_line1: ''
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
    if (this.props.checkForm) {
      this.props.checkForm((err, values)=>{
          if(!err) {
            this.generateToken()
          }
      });
    } else {
      this.generateToken()
    }
  };
  
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  generateToken = () => {
    if (this.props.token) {
      return this.props.onToken(this.props.token);
    }
    if (this.props.stripe) {
      const {name, address_line1} = this.state;
      this.props.stripe
        .createToken({name, address_line1})
        .then((payload) => {
          if (payload.token && payload.token.id) {
            this.props.onToken(payload.token.id)
            this.setState({
              error: '',
            });
          }else{
            this.setState({
              error: payload.error && payload.error.message
            });
          }
        });
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  }

  changeTab = (data) =>{
    this.setState({
      ActiveTab: data
    });
  }

  render() {
    const { ActiveTab, error } = this.state
    const { title, isUpdate } = this.props;
    return (
      <StyledStripeForm>
        <Card
          type="inner"
          title={title || 'Select your payment method'}>
          <Row>
            <Col span={12}>
              <Button type={ActiveTab === "creditCard" ? "primary" : ""} className="btn-credit" onClick={() => {this.changeTab('creditCard')}}>
                <Icon type="credit-card" theme="outlined"/>Credit Card
              </Button>
            </Col>
            <Col span={12}>
              <Button type={ActiveTab === "payPal" ? "primary" : ""} className="btn-paypal" onClick={() => {this.changeTab('payPal')}}>
               PayPal
              </Button>
            </Col>
          </Row>&nbsp;
          <span className="text-denger">{error}</span>
          {
            ActiveTab === "creditCard" &&
            <StyledMember>
              {!isUpdate && <Input name="name" placeholder="Name" style={{marginBottom: 5}} onChange={this.onChange} />}
              {!isUpdate && <Input name="address_line1" placeholder="Address" style={{marginBottom: 5}} onChange={this.onChange} />}
              <CardNumberElement
                className="ant-input"
                name="cardNumber"/>
              <Row gutter={16}>
                <Col span={12}>
                  <CardExpiryElement className="ant-input" name="cardExpiry"/>
                </Col>
                <Col span={12}>
                  <CardCVCElement className="ant-input" name="cvc"/>
                </Col>
              </Row>
            </StyledMember>}
          {
            ActiveTab === "payPal" && <p style={{minHeight: 58}}>Coming soon...</p>
          }
        </Card>

        <Button type="primary" className="btn-con" onClick={this.handleSubmit}><Icon type="lock" /> {this.props.buttonText || 'Pay'}</Button>
      </StyledStripeForm>
    );
  }
}
const SplitForm = injectStripe(_SplitForm);

class StripeForm extends React.Component {
  render() {
    return(<StripeProvider apiKey={global_config.stripeToken}>

        <Elements>
          <SplitForm onToken={this.props.onToken} isUpdate={this.props.isUpdate} token={this.props.token} checkForm={this.props.checkForm} title={this.props.title} buttonText={this.props.buttonText} />
        </Elements>

    </StripeProvider>)
  }
}

export default StripeForm


// WEBPACK FOOTER //
// ./src/components/shop-pages/StripeForm.js